import { defineStore, setActivePinia } from "pinia";
import { getCurrentInstance } from "vue"

import { $$language, $$t } from "@/i18n/i18n.js";
import useUserDataStore from "@/store/userDataStore.js";
import layoutConfig from "@/config/layoutConfig";
import globalConfig, { ModuleOpenStateControl } from "@/config/config.js";
import apiCommon from "@/api/api/apiCommon.js";
import dateTimeUtil from "@/utils/dateTime.js";
import tools from "@/utils/tools.js";
import useDialogStore from "@/store/dialogStore.js";
import { parseCookies, getCookie, setCookie, setCookies } from "@/utils/cookie.js";
const SSR = import.meta.SSR
const useCreateRenderType = defineStore({
  id: "createRenderType",
  state: () => {
    const createState = {
      create_createEditOpenState: "max",
      nocreate_createEditOpenState: "min", // max, playermax, min, playermin
      bgmCreate_createEditOpenState: 'min',
      createEditMode: 'hard', // easy hard
      editorOpenState: 'max',
      bgmCreateEditMode: 'easy',
      createRenderType: layoutConfig.renderType, // mobile, pc
    }
    let cookies = {};
    if (SSR) {
      cookies = parseCookies(getCurrentInstance()?.appContext?.config?.globalProperties?.$cookie ?? '') || {};
      console.log('cookies', coogetCurrentInstance()?.appContext?.config?.globalProperties?.$cookie ?? '')
      // } else {
      //   cookies = parseCookies(document.cookie) || {};
    }

    const {
      create_createEditOpenState = "max",
      nocreate_createEditOpenState = "min", // max, playermax, min, playermin
      bgmCreate_createEditOpenState = 'min',
      createEditMode = 'hard', // easy hard
      editorOpenState = 'max',
      bgmCreateEditMode = 'easy',
      createRenderType = layoutConfig.renderType,
    } = cookies;

    Object.assign(createState, {
      create_createEditOpenState,
      nocreate_createEditOpenState,
      bgmCreate_createEditOpenState,
      createEditMode,
      editorOpenState,
      bgmCreateEditMode,
      createRenderType,
    });
    return {
      lastCreateTabName: 'create',
      curOpModule: "createEdit", // createEdit, createResult
      curBgmOpModule: "bgmCreateEdit", // bgmCreateEdit, createResult
      globalPlayerOpened: false,
      isShowFeedCreateGuid: false,
      createEditGuidTourVisible: false,
      createEditGuidTourCurStep: 0,
      feedSubscribeIsRender: false,
      activityConfig: null,
      headSummonVisible: false,
      headSummonVisibleTimeScamps: new Date().getTime(),
      curHighlightReferType: null,
      activityVisible: false,
      activityConfigTab: "create", // videos
      createEditModelBreath: false,
      createEditGuidTourControlVisible: false,
      createModeGuideTabState: false,
      lastSimilarCreateType: "similaradvanced",
      awayHideFeedSubscribeIsRender: false,
      vocalCornerMarkVisible: new Date() > new Date(
        ModuleOpenStateControl.create.vacalCustomNewCornerMarkEndTime
      ) ? false : ModuleOpenStateControl.create.vocalCustom ? true : false,
      lyricOptimizeGuidVisibleCount: 0,
      ...createState
    };
  },
  actions: {
    initCookiesData(cookies) {
      const {
        create_createEditOpenState = "max",
        nocreate_createEditOpenState = "min", // max, playermax, min, playermin
        bgmCreate_createEditOpenState = 'min',
        createEditMode = 'hard', // easy hard
        editorOpenState = 'max',
        bgmCreateEditMode = 'easy',
      } = parseCookies(cookies) || {};

      this.create_createEditOpenState = create_createEditOpenState;
      this.nocreate_createEditOpenState = nocreate_createEditOpenState;
      this.bgmCreate_createEditOpenState = bgmCreate_createEditOpenState;
      this.createEditMode = createEditMode;
      this.editorOpenState = editorOpenState;
      this.bgmCreateEditMode = bgmCreateEditMode;
      
    },
    initLocalState() {
      let datasC = {};
      let headSummonCacheData = {};
      let cookies = {};
      try {

        datasC = JSON.parse(window.localStorage.getItem(
          `${globalConfig.appname}_createLayoutData`
        ) ?? "{}");
        cookies = parseCookies(document.cookie) || {};
      } catch (e) {
        datasC = {};
        cookies = {};
      }
      try {
        headSummonCacheData = JSON.parse(
          localStorage.getItem(
            `${globalConfig.appname}_headSummonvisible_cache_data`
          ) ?? "{}"
        );
      } catch (e) {
        headSummonCacheData = {};
      }
      let headSummonVisible = false;
      if (
        headSummonCacheData?.activityConfig &&
        (headSummonCacheData.headSummonVisible ||
          !headSummonCacheData?.headSummonVisibleTimeScamps ||
          (dateTimeUtil.isPastEndOfDay(new Date(headSummonCacheData?.headSummonVisibleTimeScamps))))
      ) {
        headSummonVisible = true;
      }
      const urlMode = tools.getUrlAllParams()?.mode;

      const {
        curOpModule = "createEdit",
        curBgmOpModule = "bgmCreateEdit",

        createEditGuidTourVisible = true,
        feedSubscribeIsRender = false,
        activityVisible = false,
        activityConfigTab = "create",
        vocalCornerMarkVisible = true,
        lastSimilarCreateType = "similaradvanced",
        lyricOptimizeGuidVisibleCount = 0,
        awayHideFeedSubscribeIsRender = false,
      } = datasC;

      const {
        create_createEditOpenState = "min",
        nocreate_createEditOpenState = "min",
        bgmCreate_createEditOpenState = 'min',
        createEditMode = "hard",
        bgmCreateEditMode = 'easy',
        editorOpenState = "min",
      } = cookies;

      this.lastCreateTabName = 'create';

      this.curOpModule = curOpModule ?? "createEdit"; // createEdit, createResult
      this.curBgmOpModule = curBgmOpModule ?? "bgmCreateEdit"; // bgmCreateEdit, createResult

      this.create_createEditOpenState = create_createEditOpenState ?? "max";
      this.nocreate_createEditOpenState = nocreate_createEditOpenState ?? "min"; // max, playermax, min, playermin
      this.bgmCreate_createEditOpenState = bgmCreate_createEditOpenState;
      this.editorOpenState = editorOpenState ?? 'max';
      this.createEditMode = ['basic', 'advanced'].includes(urlMode) ? urlMode == 'basic' ? 'easy' : 'hard' : (createEditMode ?? "hard"); // easy hard
      this.bgmCreateEditMode = bgmCreateEditMode ?? 'easy';
      this.createRenderType = layoutConfig.renderType;

      this.globalPlayerOpened = false;
      this.isShowFeedCreateGuid = !createEditGuidTourVisible;
      this.createEditGuidTourVisible = createEditGuidTourVisible;
      this.createEditGuidTourCurStep = 0;
      this.feedSubscribeIsRender = feedSubscribeIsRender;
      this.activityConfig = headSummonCacheData?.activityConfig ?? null;
      this.headSummonVisible = headSummonVisible;
      this.headSummonVisibleTimeScamps = headSummonCacheData?.headSummonVisibleTimeScamps ?? new Date().getTime();
      this.curHighlightReferType = null;
      this.activityVisible = activityVisible ?? false;
      this.activityConfigTab = activityConfigTab ?? "create"; // videos
      this.createEditModelBreath = false;
      this.createEditGuidTourControlVisible = false;
      this.createModeGuideTabState = false;
      this.lastSimilarCreateType = lastSimilarCreateType ?? "similaradvanced";
      this.vocalCornerMarkVisible = new Date() > new Date(
        ModuleOpenStateControl.create.vacalCustomNewCornerMarkEndTime
      ) ? false : ModuleOpenStateControl.create.vocalCustom ? (vocalCornerMarkVisible ?? true) : false;
      this.lyricOptimizeGuidVisibleCount = lyricOptimizeGuidVisibleCount ?? 0;
      this.awayHideFeedSubscribeIsRender = awayHideFeedSubscribeIsRender ?? false;
    },
    clearData() {
      this.feedSubscribeIsRender = false;
      this.awayHideFeedSubscribeIsRender = false;
      this.cacheLayoutData();
    },
    toggleLyricOptimizeGuidVisible(isVisible) {
      if (this.lyricOptimizeGuidVisibleCount == 1 && isVisible) {
        return
      }
      this.lyricOptimizeGuidVisibleCount = this.lyricOptimizeGuidVisibleCount + 1;
      this.cacheLayoutData();
    },
    setLyricOptimizeGuidVisibleCount(count) {
      this.lyricOptimizeGuidVisibleCount = count;
      this.cacheLayoutData();
    },
    setLastSimilarCreateType(lastSimilarCreateType) {
      this.lastSimilarCreateType = lastSimilarCreateType;
      this.cacheLayoutData();
    },
    setVocalCornerMarkVisible(vocalCornerMarkVisible) {
      this.vocalCornerMarkVisible = vocalCornerMarkVisible;
      this.cacheLayoutData();
    },
    setFeedSubscribeIsRender(isRender) {
      if (!isRender) {
        this.feedSubscribeIsRender = isRender
        this.awayHideFeedSubscribeIsRender = true;
        this.cacheLayoutData();
      } else {
        if (!this.awayHideFeedSubscribeIsRender) {
          this.feedSubscribeIsRender = true
        }
      }
      this.cacheLayoutData();
    },
    setCreateEditGuidTourCurStep(index) {
      this.createEditGuidTourCurStep = index
    },
    setCreateEditGuidTourVisible(visible) {
      const dialogStore = useDialogStore();
      this.createEditGuidTourVisible = visible
      this.cacheLayoutData();
      if (!visible) {
        dialogStore.clearAdvGuideDialog()
        dialogStore.getPopupShow()
        // @todo chongshan
      }
    },
    showCreateEditGuidTourControlVisible() {
      const dialogStore = useDialogStore();
      if (this.createEditGuidTourVisible) {
        this.createEditGuidTourControlVisible = true
        return true
      } else {
        // dialogStore.getPopupShow()
        return false
        // 弹你的 @todo chongshan
      }
    },
    setRenderType(renderType) {
      this.createRenderType = renderType;
    },
    setCurOpModule(curOpModule, isOpenCreate) {
      this.curOpModule = curOpModule;
      this.toggleCreateEditOpenState(isOpenCreate, true);
    },

    setBgmCurOpModule(curOpModule, isOpenCreate) {
      this.curBgmOpModule = curOpModule;
      this.toggleBgmCreateEditOpenState(isOpenCreate);
    },
    setCreateEditOpenState(createEditOpenState, page) {
      this[`${page}_createEditOpenState`] = createEditOpenState;
      this.cacheLayoutData();
    },
    toggleActivityVisible(activityVisible) {
      this.activityVisible = activityVisible;
      this.cacheLayoutData();
    },
    setActivityConfigTab(curTab) {
      this.activityConfigTab = curTab;
      this.cacheLayoutData();
    },
    setCreateEditModelBreath(createEditModelBreath) {
      this.createEditModelBreath = createEditModelBreath;
      this.cacheLayoutData();
    },
    updataCreateEditOpenState(globalPlayerOpened) {
      // setPlayData call
      const isCreate = window.location.pathname.indexOf("create") > -1;
      this.globalPlayerOpened = globalPlayerOpened;
    },
    cacheLayoutData() {
      window.localStorage.setItem(
        `${globalConfig.appname}_createLayoutData`,
        JSON.stringify({
          createEditGuidTourVisible: this.createEditGuidTourVisible,
          curOpModule: this.curOpModule,
          curBgmOpModule: this.curBgmOpModule,
          activityConfigTab: this.activityConfigTab,
          activityVisible: this.activityVisible,
          createEditModelBreath: this.createEditModelBreath,
          vocalCornerMarkVisible: this.vocalCornerMarkVisible,
          lastSimilarCreateType: this.lastSimilarCreateType,
          lyricOptimizeGuidVisibleCount: this.lyricOptimizeGuidVisibleCount,
          feedSubscribeIsRender: this.feedSubscribeIsRender,
          awayHideFeedSubscribeIsRender: this.awayHideFeedSubscribeIsRender,
        })
      );
      setCookies({
        createRenderType: this.createRenderType,
        createEditMode: this.createEditMode,
        bgmCreateEditMode: this.bgmCreateEditMode,
        create_createEditOpenState: this.create_createEditOpenState,
        nocreate_createEditOpenState: this.nocreate_createEditOpenState,
        bgmCreate_createEditOpenState: this.bgmCreate_createEditOpenState,
        editorOpenState: this.editorOpenState,
      });
    },
    initCacheLayoutData() {
      const layoutData = window.localStorage.getItem(
        `${globalConfig.appname}_createLayoutData`
      );
      const cookies = parseCookies(document.cookie) || {};
      const urlMode = tools.getUrlAllParams()?.mode;
      if (layoutData) {
        const {
          curOpModule = "createEdit",
          curBgmOpModule = "bgmCreateEdit",
          createEditGuidTourVisible = true,
          awayHideFeedSubscribeIsRender = false,
        } = JSON.parse(layoutData ?? "{}");

        const {
          create_createEditOpenState = "max",
          nocreate_createEditOpenState = "min",
          bgmCreate_createEditOpenState = "min",
          createEditMode = "hard",
          bgmCreateEditMode = 'easy',
          editorOpenState = "max",
        } = cookies;

        this.curOpModule = curOpModule;
        this.curBgmOpModule = curBgmOpModule;

        this.createEditMode = ['basic', 'advanced'].includes(urlMode) ? urlMode == 'basic' ? 'easy' : 'hard' : (createEditMode ?? "hard");
        this.bgmCreateEditMode = bgmCreateEditMode;
        this.create_createEditOpenState = urlMode != '' ? 'max' : create_createEditOpenState;
        this.nocreate_createEditOpenState = nocreate_createEditOpenState;
        this.bgmCreate_createEditOpenState = bgmCreate_createEditOpenState;
        this.editorOpenState = editorOpenState ?? 'max';

        this.createEditGuidTourVisible = createEditGuidTourVisible;
        this.awayHideFeedSubscribeIsRender = awayHideFeedSubscribeIsRender;
      }
    },
    toggleCreateEditOpenState(isOpen, isSwitch) {
      const appContext = window.vueApp?.appContext;
      if (isOpen) {
        this.nocreate_createEditOpenState = this.globalPlayerOpened
          ? "playermax"
          : "max";
      } else {
        this.nocreate_createEditOpenState = this.globalPlayerOpened
          ? "playermin"
          : "min";
      }
      this.create_createEditOpenState = this.nocreate_createEditOpenState;
      if (this.createRenderType == "mobile" && !isSwitch) {
        appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl);
      }
      this.cacheLayoutData();
    },
    toggleEditorOpenState(isOpen) {
      console.log('isOpen 🔥', isOpen)
      this.editorOpenState = isOpen ? 'max' : 'min';
      this.cacheLayoutData();
    },
    toggleBgmCreateEditOpenState(isOpen) {
      this.bgmCreate_createEditOpenState = isOpen ? "max" : "min";
      this.cacheLayoutData();
    },
    setCurHighlightReferType(referType) {
      this.curHighlightReferType = referType;
    },
    setCreateEditMode(mode, isGuid) {
      this.createModeGuideTabState = isGuid;
      this.createEditMode = mode;
      this.cacheLayoutData();
    },
    setBgmCreateEditMode(mode) {
      this.bgmCreateEditMode = mode;
      this.cacheLayoutData();
    },
    setActivityConfig(config) {
      this.activityConfig = config;
      localStorage.setItem(
        `${globalConfig.appname}_headSummonvisible_cache_data`,
        JSON.stringify({
          activityConfig: this.activityConfig,
          headSummonVisible: this.headSummonVisible,
          headSummonVisibleTimeScamps: this.headSummonVisibleTimeScamps,
        })
      );
    },
    setHeadSummonVisible(visible) {
      this.headSummonVisible = visible;
      this.headSummonVisibleTimeScamps = new Date().getTime();
      localStorage.setItem(
        `${globalConfig.appname}_headSummonvisible_cache_data`,
        JSON.stringify({
          activityConfig: this.activityConfig,
          headSummonVisible: this.headSummonVisible,
          headSummonVisibleTimeScamps: this.headSummonVisibleTimeScamps,
        })
      );
    },

    initActivityConfig(activityConfigData) {
      const { activityConfig } = this;
      if (
        activityConfigData?.id &&
        activityConfig?.id !=
        activityConfigData?.id
      ) {
        this.activityConfig = activityConfigData;
        this.headSummonVisible = true;
        localStorage.setItem(
          `${globalConfig.appname}_headSummonvisible_cache_data`,
          JSON.stringify({
            activityConfig: this.activityConfig,
            headSummonVisible: this.headSummonVisible,
            headSummonVisibleTimeScamps: this.headSummonVisibleTimeScamps,
          })
        );
      }
      else {
        this.activityConfig = activityConfigData;
        if (!this.activityConfig?.id || this.activityConfig?.State == 2) { // 代表活动下线了
          this.headSummonVisible = false;
          localStorage.removeItem(
            `${globalConfig.appname}_headSummonvisible_cache_data`,
          );
        }
      }
    }
  },
});

export default useCreateRenderType;
